import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GeneralService } from '../services/general.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateService } from '../services/date.service';
import { EditorComponent } from '../editor/editor.component';
// Angular Editor Supprimer
// import { AngularEditorConfig } from '@kolkov/angular-editor';
@Component({
  selector: 'app-avt-alert',
  templateUrl: './avt-alert.component.html',
  styleUrls: ['./avt-alert.component.scss'],
})
export class AvtAlertComponent implements OnInit {
  constructor(
    public route: ActivatedRoute,
    public generalService: GeneralService,
    public dialogRef: MatDialogRef<AvtAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public dateService: DateService
  ) {}
  alert;
  alertInit;
  exist: boolean = true;
  dsabledBtnEnregister: boolean = false;
  datasourceInterlocuteur;
  configInfoBasPage = { height: 120 };
  @ViewChild('editor', { static: false }) editor: EditorComponent;
  listeStatut = [
    { text: 'En attente', value: 0 },
    { text: 'Dépassé', value: 1 },
    { text: 'Traitté', value: 2 },
    { text: 'Reporté', value: 3 },
  ];
  // Angular Editor Supprimer
  // editorConfig: AngularEditorConfig = this.generalService.editorConfig;
  ngOnInit() {
    this.alert = {};
    this.getAlert();
    if (this.data.type == 'client') this.getDataInterlocuteur();
  }
  getAlert() {
    if (this.data.avtAlerte_Id == '-1') var url = this.generalService.urlAlert;
    else
      var url = this.generalService.urlAlert + '&val=' + this.data.avtAlerte_Id;
    this.generalService.rechercheTable(url).subscribe((rec) => {
      this.alertInit = rec;
      this.alert = this.alertInit.avtAlerte[0];
      this.editor.setHTML(this.alert.avtAlerte_Texte);
    });
  }
  enregistrer(f) {
    if (f.form.valid) {
      if (this.generalService.userPerso.UserName) {
        this.exist = false;
        this.dsabledBtnEnregister = true;
        this.alert.Tiers_code = this.data.code;
        if (this.data.type == 'client')
          this.alert.avtAlerte_Interlocuteur = this.alert.TiersC_Id;
        this.alert.User_Id = this.generalService.userPerso.UserName;
        // this.alert.avtAlerte_Statut = 0;
        this.alert.avtAlerte_Date = this.dateService.setToFormatDateServerStr(
          new Date(this.alert.avtAlerte_Date)
        );
        this.generalService.enregisterTable(this.alertInit).subscribe(
          (alert) => {
            if (
              alert.code != '' &&
              alert.code != null &&
              alert.code != undefined
            )
              this.alert.avtAlerte_Id = alert.code;
            this.dialogRef.close({ status: true, alert: this.alert });
          },
          (error) => {
            this.dialogRef.close({ status: false });
          }
        );
      }
    }
  }
  close() {
    this.dialogRef.close({ status: false });
  }
  getDataInterlocuteur() {
    this.generalService
      .rechercheTable(
        this.generalService.urlListeInterlocuteur + this.data.code
      )
      .subscribe((data) => {
        this.datasourceInterlocuteur = this.generalService.sort(
          data,
          'TiersC_Nom'
        );
      });
  }
  editorAction(event) {
    if ((event.action = 'editor-change')) {
      this.alert.avtAlerte_Texte = event.editor.getHTML();
    }
  }
}
